module.exports = __webpack_public_path__ + "static/media/FM_EU_Cookie Policy_March_2025.53df324c.pdf";